window.statesTimeZones = function() {

	// Country States
	var statesByCountry = {
		"AU": {
			"ACT": { name: "Australian Capital Territory" },
			"NSW": { name: "New South Wales" },
			"NT": { name: "Northern Territory" },
			"QLD": { name: "Queensland" },
			"SA": { name: "South Australia" },
			"TAS": { name: "Tasmania" },
			"VIC": { name: "Victoria" },
			"WA": { name: "Western Australia" },
		},
		"BE": {
			"BRU": { name: "Brussels" },
			"VLG": { name: "Flanders" },
			"WAL": { name: "Wallonia" },
		},
		"CA": {
			"AB": { name: "Alberta" },
			"BC": { name: "British Columbia" },
			"MB": { name: "Manitoba" },
			"NB": { name: "New Brunswick" },
			"NL": { name: "Newfoundland and Labrador" },
			"NT": { name: "Northwest Territories" },
			"NS": { name: "Nova Scotia" },
			"NU": { name: "Nunavut" },
			"ON": { name: "Ontario" },
			"PE": { name: "Prince Edward Island" },
			"QC": { name: "Quebec" },
			"SK": { name: "Saskatchewan" },
			"YT": { name: "Yukon" },
		},
		"CH": {
			"AG": { name: "Aargau" },
			"AR": { name: "Appenzell Ausserrhoden" },
			"AI": { name: "Appenzell Innerhoden" },
			"BL": { name: "Basel-Landschaft" },
			"BS": { name: "Basel-Stadt" },
			"BE": { name: "Bern" },
			"FR": { name: "Fribourg" },
			"GE": { name: "Genève" },
			"GL": { name: "Glarus" },
			"GR": { name: "Graubünden" },
			"JU": { name: "Jura" },
			"LU": { name: "Luzern" },
			"NE": { name: "Neuchâtel" },
			"NW": { name: "Nidwalden" },
			"OW": { name: "Obwalden" },
			"SG": { name: "Sankt Gallen" },
			"SH": { name: "Schaffhausen" },
			"SZ": { name: "Schwyz" },
			"SO": { name: "Solothurn" },
			"TG": { name: "Thurgau" },
			"TI": { name: "Ticino" },
			"UR": { name: "Uri" },
			"VS": { name: "Valais" },
			"VD": { name: "Vaud" },
			"ZG": { name: "Zug" },
			"ZH": { name: "Zürich" },
		},
		"DE": {
			"BW": { name: "Baden-Württemberg" },
			"BY": { name: "Bayern" },
			"BE": { name: "Berlin" },
			"BB": { name: "Brandenburg" },
			"HB": { name: "Bremen" },
			"HH": { name: "Hamburg" },
			"HE": { name: "Hessen" },
			"MV": { name: "Mecklenburg-Vorpommern" },
			"NI": { name: "Niedersachsen" },
			"NW": { name: "Nordrhein-Westfalen" },
			"RP": { name: "Rheinland-Pfalz" },
			"SL": { name: "Saarland" },
			"SN": { name: "Sachsen" },
			"ST": { name: "Sachsen-Anhalt" },
			"SH": { name: "Schleswig-Holstein" },
			"TH": { name: "Thüringen" },
		},
		"DK": {
			"84": { name: "Hovedstaden" },
			"GL-KU": { name: "Kujalleq" },
			"82": { name: "Midtjylland" },
			"FO-01": { name: "Norderøerne" },
			"81": { name: "Nordjylland" },
			"FO-06": { name: "Østerø" },
			"GL-QA": { name: "Qaasuitsup" },
			"GL-QE": { name: "Qeqqata" },
			"FO-02": { name: "Sandø" },
			"GL-SM": { name: "Sermersooq" },
			"85": { name: "Sjælland" },
			"FO-03": { name: "Strømø" },
			"FO-04": { name: "Suderø" },
			"83": { name: "Syddanmark" },
			"FO-05": { name: "Vågø" },
		},
		"FI": {
			"FI-01": { name: "Ahvenanmaan maakunta" },
			"FI-02": { name: "Etelä-Karjala" },
			"FI-03": { name: "Etelä-Pohjanmaa" },
			"FI-04": { name: "Etelä-Savo" },
			"FI-05": { name: "Kainuu" },
			"FI-06": { name: "Kanta-Häme" },
			"FI-07": { name: "Keski-Pohjanmaa" },
			"FI-08": { name: "Keski-Suomi" },
			"FI-09": { name: "Kymenlaakso" },
			"FI-10": { name: "Lappi" },
			"FI-16": { name: "Päijät-Häme" },
			"FI-11": { name: "Pirkanmaa" },
			"FI-12": { name: "Pohjanmaa" },
			"FI-13": { name: "Pohjois-Karjala" },
			"FI-14": { name: "Pohjois-Pohjanmaa" },
			"FI-15": { name: "Pohjois-Savo" },
			"FI-17": { name: "Satakunta" },
			"FI-18": { name: "Uusimaa" },
			"FI-19": { name: "Varsinais-Suomi" },
		},
		"GB": {
			"ABE": { name: "Aberdeen City" },
			"ABD": { name: "Aberdeenshire" },
			"ANS": { name: "Angus" },
			"ANN": { name: "Antrim and Newtownabbey" },
			"AND": { name: "Ards and North Down" },
			"AGB": { name: "Argyll and Bute" },
			"ABC": { name: "Armagh, Banbridge and Craigavon" },
			"BDG": { name: "Barking and Dagenham" },
			"BNE": { name: "Barnet" },
			"BNS": { name: "Barnsley" },
			"BAS": { name: "Bath and North East Somerset" },
			"BDF": { name: "Bedford" },
			"BFS": { name: "Belfast" },
			"BEX": { name: "Bexley" },
			"BIR": { name: "Birmingham" },
			"BBD": { name: "Blackburn with Darwen" },
			"BPL": { name: "Blackpool" },
			"BGW": { name: "Blaenau Gwent" },
			"BOL": { name: "Bolton" },
			"BMH": { name: "Bournemouth" },
			"BRC": { name: "Bracknell Forest" },
			"BRD": { name: "Bradford" },
			"BEN": { name: "Brent" },
			"BGE": { name: "Bridgend" },
			"BNH": { name: "Brighton and Hove" },
			"BST": { name: "Bristol, City of" },
			"BRY": { name: "Bromley" },
			"BKM": { name: "Buckinghamshire" },
			"BUR": { name: "Bury" },
			"CAY": { name: "Caerphilly" },
			"CLD": { name: "Calderdale" },
			"CAM": { name: "Cambridgeshire" },
			"CMD": { name: "Camden" },
			"CRF": { name: "Cardiff" },
			"CMN": { name: "Carmarthenshire" },
			"CCG": { name: "Causeway Coast and Glens" },
			"CBF": { name: "Central Bedfordshire" },
			"CGN": { name: "Ceredigion" },
			"CHE": { name: "Cheshire East" },
			"CHW": { name: "Cheshire West and Chester" },
			"CLK": { name: "Clackmannanshire" },
			"CWY": { name: "Conwy" },
			"CON": { name: "Cornwall" },
			"COV": { name: "Coventry" },
			"CRY": { name: "Croydon" },
			"CMA": { name: "Cumbria" },
			"DAL": { name: "Darlington" },
			"DEN": { name: "Denbighshire" },
			"DER": { name: "Derby" },
			"DBY": { name: "Derbyshire" },
			"DRS": { name: "Derry and Strabane" },
			"DEV": { name: "Devon" },
			"DNC": { name: "Doncaster" },
			"DOR": { name: "Dorset" },
			"DUD": { name: "Dudley" },
			"DGY": { name: "Dumfries and Galloway" },
			"DND": { name: "Dundee City" },
			"DUR": { name: "Durham County" },
			"EAL": { name: "Ealing" },
			"EAY": { name: "East Ayrshire" },
			"EDU": { name: "East Dunbartonshire" },
			"ELN": { name: "East Lothian" },
			"ERW": { name: "East Renfrewshire" },
			"ERY": { name: "East Riding of Yorkshire" },
			"ESX": { name: "East Sussex" },
			"EDH": { name: "Edinburgh, City of" },
			"ELS": { name: "Eilean Siar" },
			"ENF": { name: "Enfield" },
			"ESS": { name: "Essex" },
			"FAL": { name: "Falkirk" },
			"FMO": { name: "Fermanagh and Omagh" },
			"FIF": { name: "Fife" },
			"FLN": { name: "Flintshire" },
			"GAT": { name: "Gateshead" },
			"GLG": { name: "Glasgow City" },
			"GLS": { name: "Gloucestershire" },
			"GRE": { name: "Greenwich" },
			"GWN": { name: "Gwynedd" },
			"HCK": { name: "Hackney" },
			"HAL": { name: "Halton" },
			"HMF": { name: "Hammersmith and Fulham" },
			"HAM": { name: "Hampshire" },
			"HRY": { name: "Haringey" },
			"HRW": { name: "Harrow" },
			"HPL": { name: "Hartlepool" },
			"HAV": { name: "Havering" },
			"HEF": { name: "Herefordshire" },
			"HRT": { name: "Hertfordshire" },
			"HLD": { name: "Highland" },
			"HIL": { name: "Hillingdon" },
			"HNS": { name: "Hounslow" },
			"IVC": { name: "Inverclyde" },
			"AGY": { name: "Isle of Anglesey" },
			"IOW": { name: "Isle of Wight" },
			"IOS": { name: "Isles of Scilly" },
			"ISL": { name: "Islington" },
			"KEC": { name: "Kensington and Chelsea" },
			"KEN": { name: "Kent" },
			"KHL": { name: "Kingston upon Hull" },
			"KTT": { name: "Kingston upon Thames" },
			"KIR": { name: "Kirklees" },
			"KWL": { name: "Knowsley" },
			"LBH": { name: "Lambeth" },
			"LAN": { name: "Lancashire" },
			"LDS": { name: "Leeds" },
			"LCE": { name: "Leicester" },
			"LEC": { name: "Leicestershire" },
			"LEW": { name: "Lewisham" },
			"LIN": { name: "Lincolnshire" },
			"LBC": { name: "Lisburn and Castlereagh" },
			"LIV": { name: "Liverpool" },
			"LND": { name: "London, City of" },
			"LUT": { name: "Luton" },
			"MAN": { name: "Manchester" },
			"MDW": { name: "Medway" },
			"MTY": { name: "Merthyr Tydfil" },
			"MRT": { name: "Merton" },
			"MEA": { name: "Mid and East Antrim" },
			"MUL": { name: "Mid Ulster" },
			"MDB": { name: "Middlesbrough" },
			"MLN": { name: "Midlothian" },
			"MIK": { name: "Milton Keynes" },
			"MON": { name: "Monmouthshire" },
			"MRY": { name: "Moray" },
			"NTL": { name: "Neath Port Talbot" },
			"NET": { name: "Newcastle upon Tyne" },
			"NWM": { name: "Newham" },
			"NWP": { name: "Newport" },
			"NMD": { name: "Newry, Mourne and Down" },
			"NFK": { name: "Norfolk" },
			"NAY": { name: "North Ayrshire" },
			"NEL": { name: "North East Lincolnshire" },
			"NLK": { name: "North Lanarkshire" },
			"NLN": { name: "North Lincolnshire" },
			"NSM": { name: "North Somerset" },
			"NTY": { name: "North Tyneside" },
			"NYK": { name: "North Yorkshire" },
			"NTH": { name: "Northamptonshire" },
			"NBL": { name: "Northumberland" },
			"NGM": { name: "Nottingham" },
			"NTT": { name: "Nottinghamshire" },
			"OLD": { name: "Oldham" },
			"ORK": { name: "Orkney Islands" },
			"OXF": { name: "Oxfordshire" },
			"PEM": { name: "Pembrokeshire" },
			"PKN": { name: "Perth and Kinross" },
			"PTE": { name: "Peterborough" },
			"PLY": { name: "Plymouth" },
			"POL": { name: "Poole" },
			"POR": { name: "Portsmouth" },
			"POW": { name: "Powys" },
			"RDG": { name: "Reading" },
			"RDB": { name: "Redbridge" },
			"RCC": { name: "Redcar and Cleveland" },
			"RFW": { name: "Renfrewshire" },
			"RCT": { name: "Rhondda, Cynon, Taff" },
			"RIC": { name: "Richmond upon Thames" },
			"RCH": { name: "Rochdale" },
			"ROT": { name: "Rotherham" },
			"RUT": { name: "Rutland" },
			"SLF": { name: "Salford" },
			"SAW": { name: "Sandwell" },
			"SCB": { name: "Scottish Borders, The" },
			"SFT": { name: "Sefton" },
			"SHF": { name: "Sheffield" },
			"ZET": { name: "Shetland Islands" },
			"SHR": { name: "Shropshire" },
			"SLG": { name: "Slough" },
			"SOL": { name: "Solihull" },
			"SOM": { name: "Somerset" },
			"SAY": { name: "South Ayrshire" },
			"SGC": { name: "South Gloucestershire" },
			"SLK": { name: "South Lanarkshire" },
			"STY": { name: "South Tyneside" },
			"STH": { name: "Southampton" },
			"SOS": { name: "Southend-on-Sea" },
			"SWK": { name: "Southwark" },
			"SHN": { name: "St. Helens" },
			"STS": { name: "Staffordshire" },
			"STG": { name: "Stirling" },
			"SKP": { name: "Stockport" },
			"STT": { name: "Stockton-on-Tees" },
			"STE": { name: "Stoke-on-Trent" },
			"SFK": { name: "Suffolk" },
			"SND": { name: "Sunderland" },
			"SRY": { name: "Surrey" },
			"STN": { name: "Sutton" },
			"SWA": { name: "Swansea" },
			"SWD": { name: "Swindon" },
			"TAM": { name: "Tameside" },
			"TFW": { name: "Telford and Wrekin" },
			"THR": { name: "Thurrock" },
			"TOB": { name: "Torbay" },
			"TOF": { name: "Torfaen" },
			"TWH": { name: "Tower Hamlets" },
			"TRF": { name: "Trafford" },
			"VGL": { name: "Vale of Glamorgan, The" },
			"WKF": { name: "Wakefield" },
			"WLL": { name: "Walsall" },
			"WFT": { name: "Waltham Forest" },
			"WND": { name: "Wandsworth" },
			"WRT": { name: "Warrington" },
			"WAR": { name: "Warwickshire" },
			"WBK": { name: "West Berkshire" },
			"WDU": { name: "West Dunbartonshire" },
			"WLN": { name: "West Lothian" },
			"WSX": { name: "West Sussex" },
			"WSM": { name: "Westminster" },
			"WGN": { name: "Wigan" },
			"WIL": { name: "Wiltshire" },
			"WNM": { name: "Windsor and Maidenhead" },
			"WRL": { name: "Wirral" },
			"WOK": { name: "Wokingham" },
			"WLV": { name: "Wolverhampton" },
			"WOR": { name: "Worcestershire" },
			"WRX": { name: "Wrexham" },
			"YOR": { name: "York" },
		},
		"GT": {
			"AV": { name: "Alta Verapaz" },
			"BV": { name: "Baja Verapaz" },
			"CM": { name: "Chimaltenango" },
			"CQ": { name: "Chiquimula" },
			"PR": { name: "El Progreso" },
			"ES": { name: "Escuintla" },
			"GU": { name: "Guatemala" },
			"HU": { name: "Huehuetenango" },
			"IZ": { name: "Izabal" },
			"JA": { name: "Jalapa" },
			"JU": { name: "Jutiapa" },
			"PE": { name: "Petén" },
			"QZ": { name: "Quetzaltenango" },
			"QC": { name: "Quiché" },
			"Re": { name: "Retalhuleu" },
			"SA": { name: "Sacatepéquez" },
			"SM": { name: "San Marcos" },
			"SR": { name: "Santa Rosa" },
			"SO": { name: "Sololá" },
			"SU": { name: "Suchitepéquez" },
			"TO": { name: "Totonicapán" },
			"ZA": { name: "Zacapa" },
		},
		"IS": {
			"7": { name: "Austurland" },
			"1": { name: "Höfuðborgarsvæði" },
			"6": { name: "Norðurland eystra" },
			"5": { name: "Norðurland vestra" },
			"8": { name: "Suðurland" },
			"2": { name: "Suðurnes" },
			"4": { name: "Vestfirðir" },
			"3": { name: "Vesturland" },
		},
		"LV": {
			"011": { name: "Ādaži" },
			"001": { name: "Aglona" },
			"002": { name: "Aizkraukle" },
			"003": { name: "Aizpute" },
			"004": { name: "Aknīste" },
			"005": { name: "Aloja" },
			"06": { name: "Alsunga" },
			"007": { name: "Alūksne" },
			"008": { name: "Amata" },
			"009": { name: "Ape" },
			"010": { name: "Auce" },
			"012": { name: "Babīte" },
			"013": { name: "Baldone" },
			"014": { name: "Baltinava" },
			"015": { name: "Balvi" },
			"016": { name: "Bauska" },
			"017": { name: "Beverīna" },
			"018": { name: "Brocēni" },
			"019": { name: "Burtnieki" },
			"020": { name: "Carnikava" },
			"022": { name: "Cēsis" },
			"021": { name: "Cesvaine" },
			"023": { name: "Cibla" },
			"024": { name: "Dagda" },
			"025": { name: "Daugavpils" },
			"DGV": { name: "Daugavpils (City)" },
			"026": { name: "Dobele" },
			"027": { name: "Dundaga" },
			"028": { name: "Durbe" },
			"029": { name: "Engure" },
			"030": { name: "Ērgļi" },
			"031": { name: "Garkalne" },
			"032": { name: "Grobiņa" },
			"033": { name: "Gulbene" },
			"034": { name: "Iecava" },
			"035": { name: "Ikšķile" },
			"036": { name: "Ilūkste" },
			"037": { name: "Inčukalns" },
			"038": { name: "Jaunjelgava" },
			"039": { name: "Jaunpiebalga" },
			"040": { name: "Jaunpils" },
			"042": { name: "Jēkabpils" },
			"JKB": { name: "Jēkabpils (City)" },
			"041": { name: "Jelgava" },
			"JEL": { name: "Jelgava (City)" },
			"JUR": { name: "Jūrmala (City)" },
			"043": { name: "Kandava" },
			"044": { name: "Kārsava" },
			"051": { name: "Ķegums" },
			"052": { name: "Ķekava" },
			"045": { name: "Kocēni" },
			"046": { name: "Koknese" },
			"047": { name: "Krāslava" },
			"048": { name: "Krimulda" },
			"049": { name: "Krustpils" },
			"050": { name: "Kuldīga" },
			"053": { name: "Lielvārde" },
			"LPX": { name: "Liepāja" },
			"055": { name: "Līgatne" },
			"054": { name: "Limbaži" },
			"056": { name: "Līvāni" },
			"057": { name: "Lubāna" },
			"058": { name: "Ludza" },
			"059": { name: "Madona" },
			"061": { name: "Mālpils" },
			"062": { name: "Mārupe" },
			"060": { name: "Mazsalaca" },
			"063": { name: "Mērsrags" },
			"064": { name: "Naukšēni" },
			"065": { name: "Nereta" },
			"066": { name: "Nīca" },
			"067": { name: "Ogre" },
			"068": { name: "Olaine" },
			"069": { name: "Ozolnieki" },
			"070": { name: "Pārgauja" },
			"071": { name: "Pāvilosta" },
			"072": { name: "Pļaviņas" },
			"073": { name: "Preiļi" },
			"074": { name: "Priekule" },
			"075": { name: "Priekuļi" },
			"076": { name: "Rauna" },
			"077": { name: "Rēzekne" },
			"REZ": { name: "Rēzekne (City)" },
			"078": { name: "Riebiņi" },
			"RIX": { name: "Rīga" },
			"079": { name: "Roja" },
			"080": { name: "Ropaži" },
			"081": { name: "Rucava" },
			"082": { name: "Rugāji" },
			"084": { name: "Rūjiena" },
			"083": { name: "Rundāle" },
			"085": { name: "Sala" },
			"086": { name: "Salacgrīva" },
			"087": { name: "Salaspils" },
			"088": { name: "Saldus" },
			"089": { name: "Saulkrasti" },
			"090": { name: "Sēja" },
			"091": { name: "Sigulda" },
			"092": { name: "Skrīveri" },
			"093": { name: "Skrunda" },
			"094": { name: "Smiltene" },
			"095": { name: "Stopiņi" },
			"096": { name: "Strenči" },
			"097": { name: "Talsi" },
			"098": { name: "Tērvete" },
			"099": { name: "Tukums" },
			"100": { name: "Vaiņode" },
			"101": { name: "Valka" },
			"VMR": { name: "Valmiera" },
			"102": { name: "Varakļāni" },
			"103": { name: "Vārkava" },
			"104": { name: "Vecpiebalga" },
			"105": { name: "Vecumnieki" },
			"106": { name: "Ventspils" },
			"VEN": { name: "Ventspils (City)" },
			"107": { name: "Viesīte" },
			"108": { name: "Viļaka" },
			"109": { name: "Viļāni" },
			"110": { name: "Zilupe" },
		},
		"MX": {
			"AGU": { name: "Aguascalientes" },
			"BCN": { name: "Baja California" },
			"BCS": { name: "Baja California Sur" },
			"CAM": { name: "Campeche" },
			"CHP": { name: "Chiapas" },
			"CHH": { name: "Chihuahua" },
			"DIF": { name: "Ciudad de México" },
			"COA": { name: "Coahuila de Zaragoza" },
			"COL": { name: "Colima" },
			"DUR": { name: "Durango" },
			"MEX": { name: "Estado de México" },
			"GUA": { name: "Guanajuato" },
			"GRO": { name: "Guerrero" },
			"HID": { name: "Hidalgo" },
			"JAL": { name: "Jalisco" },
			"MIC": { name: "Michoacán de Ocampo" },
			"MOR": { name: "Morelos" },
			"NAY": { name: "Nayarit" },
			"NLE": { name: "Nuevo León" },
			"OAX": { name: "Oaxaca" },
			"PUE": { name: "Puebla" },
			"QUE": { name: "Querétaro de Arteaga" },
			"ROO": { name: "Quintana Roo" },
			"SLP": { name: "San Luis Potosí" },
			"SIN": { name: "Sinaloa" },
			"SON": { name: "Sonora" },
			"TAB": { name: "Tabasco" },
			"TAM": { name: "Tamaulipas" },
			"TLA": { name: "Tlaxcala" },
			"VER": { name: "Veracruz" },
			"YUC": { name: "Yucatán" },
			"ZAC": { name: "Zacatecas" },
		},
		"NO": {
			"02": { name: "Akershus" },
			"09": { name: "Aust-Agder" },
			"06": { name: "Buskerud" },
			"20": { name: "Finnmark" },
			"04": { name: "Hedmark" },
			"12": { name: "Hordaland" },
			"22": { name: "Jan Mayen" },
			"15": { name: "Møre og Romsdal" },
			"18": { name: "Nordland" },
			"17": { name: "Nord-Trøndelag" },
			"05": { name: "Oppland" },
			"03": { name: "Oslo" },
			"01": { name: "Østfold" },
			"11": { name: "Rogaland" },
			"14": { name: "Sogn og Fjordane" },
			"16": { name: "Sør-Trøndelag" },
			"21": { name: "Svalbard" },
			"08": { name: "Telemark" },
			"19": { name: "Troms" },
			"10": { name: "Vest-Agder" },
			"07": { name: "Vestfold" },
		},
		"NZ": {
			"AUK": { name: "Auckland" },
			"BOP": { name: "Bay of Plenty" },
			"CAN": { name: "Canterbury" },
			"CIT": { name: "Chatham Islands Territory" },
			"GIS": { name: "Gisborne" },
			"HKB": { name: "Hawke's Bay" },
			"MWT": { name: "Manawatu-Wanganui" },
			"MBH": { name: "Marlborough" },
			"NSN": { name: "Nelson" },
			"NTL": { name: "Northland" },
			"OTA": { name: "Otago" },
			"STL": { name: "Southland" },
			"TKI": { name: "Taranaki" },
			"TAS": { name: "Tasman" },
			"WKO": { name: "Waikato" },
			"WGN": { name: "Wellington" },
			"WTC": { name: "West Coast" },
		},
		"PR": {
		},
		"SE": {
			"K": { name: "Blekinge" },
			"W": { name: "Dalarna" },
			"X": { name: "Gävleborg" },
			"I": { name: "Gotland" },
			"N": { name: "Halland" },
			"Z": { name: "Jämtland" },
			"F": { name: "Jönköping" },
			"H": { name: "Kalmar" },
			"G": { name: "Kronoberg" },
			"BD": { name: "Norrbotten" },
			"T": { name: "Örebro" },
			"E": { name: "Östergötland" },
			"M": { name: "Skåne" },
			"D": { name: "Södermanland" },
			"AB": { name: "Stockholm" },
			"C": { name: "Uppsala" },
			"S": { name: "Värmland" },
			"AC": { name: "Västerbotten" },
			"Y": { name: "Västernorrland" },
			"U": { name: "Västmanland" },
			"O": { name: "Västra Götaland" },
		},
		"SG": {
			"01": { name: "Central Singapore" },
			"02": { name: "North East" },
			"03": { name: "North West" },
			"04": { name: "South East" },
			"05": { name: "South West" },
		},
		"US": {
			"AL": { name: "Alabama" },
			"AK": { name: "Alaska" },
			"AS": { name: "American Samoa" },
			"AZ": { name: "Arizona" },
			"AR": { name: "Arkansas" },
			"AA": { name: "Armed Forces Americas" },
			"AE": { name: "Armed Forces Europe, Canada, Africa and Middle East" },
			"AP": { name: "Armed Forces Pacific" },
			"CA": { name: "California" },
			"CO": { name: "Colorado" },
			"CT": { name: "Connecticut" },
			"DE": { name: "Delaware" },
			"DC": { name: "District of Columbia" },
			"FL": { name: "Florida" },
			"GA": { name: "Georgia" },
			"GU": { name: "Guam" },
			"HI": { name: "Hawaii" },
			"ID": { name: "Idaho" },
			"IL": { name: "Illinois" },
			"IN": { name: "Indiana" },
			"IA": { name: "Iowa" },
			"KS": { name: "Kansas" },
			"KY": { name: "Kentucky" },
			"LA": { name: "Louisiana" },
			"ME": { name: "Maine" },
			"MH": { name: "Marshall Islands" },
			"MD": { name: "Maryland" },
			"MA": { name: "Massachusetts" },
			"MI": { name: "Michigan" },
			"FM": { name: "Micronesia" },
			"MN": { name: "Minnesota" },
			"MS": { name: "Mississippi" },
			"MO": { name: "Missouri" },
			"MT": { name: "Montana" },
			"NE": { name: "Nebraska" },
			"NV": { name: "Nevada" },
			"NH": { name: "New Hampshire" },
			"NJ": { name: "New Jersey" },
			"NM": { name: "New Mexico" },
			"NY": { name: "New York" },
			"NC": { name: "North Carolina" },
			"ND": { name: "North Dakota" },
			"MP": { name: "Northern Mariana Islands" },
			"OH": { name: "Ohio" },
			"OK": { name: "Oklahoma" },
			"OR": { name: "Oregon" },
			"PW": { name: "Palau" },
			"PA": { name: "Pennsylvania" },
			"PR": { name: "Puerto Rico" },
			"RI": { name: "Rhode Island" },
			"SC": { name: "South Carolina" },
			"SD": { name: "South Dakota" },
			"TN": { name: "Tennessee" },
			"TX": { name: "Texas" },
			"UT": { name: "Utah" },
			"VT": { name: "Vermont" },
			"VI": { name: "Virgin Islands" },
			"VA": { name: "Virginia" },
			"WA": { name: "Washington" },
			"WV": { name: "West Virginia" },
			"WI": { name: "Wisconsin" },
			"WY": { name: "Wyoming" },
		},
		"VI": {
			"SCR": { name: "St. Croix" },
			"SJO": { name: "St. John" },
			"STH": { name: "St. Thomas" },
		},
		"ZA": {
			"EC": { name: "Eastern Cape" },
			"FS": { name: "Free State" },
			"GT": { name: "Gauteng" },
			"NL": { name: "KwaZulu-Natal" },
			"LP": { name: "Limpopo" },
			"MP": { name: "Mpumalanga" },
			"NW": { name: "North West" },
			"NC": { name: "Northern Cape" },
			"WC": { name: "Western Cape" },
		},
	};

	// Country Timezones
	var timeZonesByCountry = {
		"AU": {
			"W. Australia Standard Time": { name: "(UTC+08:00) Perth" },
			"Aus Central W. Standard Time": { name: "(UTC+08:45) Eucla" },
			"AUS Central Standard Time": { name: "(UTC+09:30) Darwin" },
			"Cen. Australia Standard Time": { name: "(UTC+09:30) Adelaide" },
			"AUS Eastern Standard Time": { name: "(UTC+10:00) Canberra, Melbourne, Sydney" },
			"E. Australia Standard Time": { name: "(UTC+10:00) Brisbane" },
			"Tasmania Standard Time": { name: "(UTC+10:00) Hobart" },
			"Lord Howe Standard Time": { name: "(UTC+10:30) Lord Howe Island" },
		},
		"BE": {
			"Romance Standard Time": { name: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris" },
		},
		"CA": {
			"Pacific Standard Time": { name: "(UTC-08:00) Pacific Time (US & Canada)" },
			"Mountain Standard Time": { name: "(UTC-07:00) Mountain Time (US & Canada)" },
			"US Mountain Standard Time": { name: "(UTC-07:00) Arizona" },
			"Yukon Standard Time": { name: "(UTC-07:00) Yukon" },
			"Canada Central Standard Time": { name: "(UTC-06:00) Saskatchewan" },
			"Central Standard Time": { name: "(UTC-06:00) Central Time (US & Canada)" },
			"Eastern Standard Time": { name: "(UTC-05:00) Eastern Time (US & Canada)" },
			"SA Pacific Standard Time": { name: "(UTC-05:00) Bogota, Lima, Quito, Rio Branco" },
			"Atlantic Standard Time": { name: "(UTC-04:00) Atlantic Time (Canada)" },
			"SA Western Standard Time": { name: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan" },
			"Newfoundland Standard Time": { name: "(UTC-03:30) Newfoundland" },
		},
		"CH": {
			"W. Europe Standard Time": { name: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna" },
		},
		"DE": {
			"W. Europe Standard Time": { name: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna" },
		},
		"DK": {
			"Romance Standard Time": { name: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris" },
		},
		"FI": {
			"FLE Standard Time": { name: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius" },
		},
		"GB": {
			"GMT Standard Time": { name: "(UTC) Dublin, Edinburgh, Lisbon, London" },
		},
		"GT": {
			"Central America Standard Time": { name: "(UTC-06:00) Central America" },
		},
		"IS": {
			"Greenwich Standard Time": { name: "(UTC) Monrovia, Reykjavik" },
		},
		"LV": {
			"FLE Standard Time": { name: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius" },
		},
		"MX": {
			"Pacific Standard Time (Mexico)": { name: "(UTC-08:00) Baja California" },
			"Mountain Standard Time": { name: "(UTC-07:00) Mountain Time (US & Canada)" },
			"Mountain Standard Time (Mexico)": { name: "(UTC-07:00) Chihuahua, La Paz, Mazatlan" },
			"US Mountain Standard Time": { name: "(UTC-07:00) Arizona" },
			"Central Standard Time": { name: "(UTC-06:00) Central Time (US & Canada)" },
			"Central Standard Time (Mexico)": { name: "(UTC-06:00) Guadalajara, Mexico City, Monterrey" },
			"Eastern Standard Time (Mexico)": { name: "(UTC-05:00) Chetumal" },
		},
		"NO": {
			"W. Europe Standard Time": { name: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna" },
		},
		"NZ": {
			"New Zealand Standard Time": { name: "(UTC+12:00) Auckland, Wellington" },
			"Chatham Islands Standard Time": { name: "(UTC+12:45) Chatham Islands" },
		},
		"PR": {
			"SA Western Standard Time": { name: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan" },
		},
		"SE": {
			"W. Europe Standard Time": { name: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna" },
		},
		"SG": {
			"Singapore Standard Time": { name: "(UTC+08:00) Kuala Lumpur, Singapore" },
		},
		"US": {
			"Aleutian Standard Time": { name: "(UTC-10:00) Aleutian Islands" },
			"Hawaiian Standard Time": { name: "(UTC-10:00) Hawaii" },
			"Alaskan Standard Time": { name: "(UTC-09:00) Alaska" },
			"Pacific Standard Time": { name: "(UTC-08:00) Pacific Time (US & Canada)" },
			"Mountain Standard Time": { name: "(UTC-07:00) Mountain Time (US & Canada)" },
			"US Mountain Standard Time": { name: "(UTC-07:00) Arizona" },
			"Central Standard Time": { name: "(UTC-06:00) Central Time (US & Canada)" },
			"Eastern Standard Time": { name: "(UTC-05:00) Eastern Time (US & Canada)" },
			"US Eastern Standard Time": { name: "(UTC-05:00) Indiana (East)" },
		},
		"VI": {
			"SA Western Standard Time": { name: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan" },
		},
		"ZA": {
			"South Africa Standard Time": { name: "(UTC+02:00) Harare, Pretoria" },
		},
	};

	return {
		statesByCountry: statesByCountry,
		timeZonesByCountry: timeZonesByCountry
	};
}();

